function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.802 34.521A55.497 55.497 0 0128 33.001c21-3 25 4.476 25 10 0 2.871 0 6-2.588 8.254C47.73 53.593 40.48 53 28 53c-13.807 0-25.076-.134-25.076-5.657 0-3.261 3.978-6.99 10.05-9.9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 39c-.5-.779-2-3.005-2-4a5 5 0 015-5c5 0 4 4 3 7"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.5,
  cy: 43,
  rx: 1.5,
  ry: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.791 38.401C9.291 37.622 9 36.795 9 35.8a5 5 0 015-5"
})), /*#__PURE__*/React.createElement("path", {
  d: "M53 18c-26.596 8.844 11.225 16.796-1 21"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.892,
  cy: 46.242,
  rx: 0.838,
  ry: 0.758,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 46c2.788.572 5.721 1.434 8 1m-8 0c1.333 1.456 3.433 2.65 8 3"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 13.092,
  cy: 43.143,
  rx: 0.838,
  ry: 0.758,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M41 42s-4 0-4 4 5 5 5 5c-5.93-1.965-8-1-10 2m-11-7c-.612 3.744 1.98 4.005 2 4-7.082.751-5.765 1.942-7 3"
}));

var SvgMouse = function SvgMouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Mouse.6251bb53.svg";
export { ForwardRef as ReactComponent };